import ExecutaRest from '../util/ExecutaRest'

class enderecoApi {

    static consultaCEP(cep) {

        var rest = new ExecutaRest();
        
        return new Promise(function (resolve, reject) {

            rest.Post('EnderecoSL.svc/rest/ObterEnderecoPorCEPREST', cep).then(retorno => {
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }
            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> listarUF: ' + error /*areaTratamento.statusText*/);
            });

        });
        
    }

}

 
export default enderecoApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/enderecoApi.js
 **/